function setupLoginExtension() {
	$(document)
		.on("click", ".remove-login", function (e) {
			e.preventDefault();
			Helper.Database.removeFromLocalStorage("email");
			Helper.Database.removeFromLocalStorage("displayName");
			Helper.Database.removeFromLocalStorage("last-user-login");
		})
		.on("click", ".logout-client-selection", function (e) {
			Helper.Database.removeFromLocalStorage("email");
			Helper.Database.removeFromLocalStorage("displayName");
			Helper.Database.removeFromLocalStorage("last-user-login");
		});
}

window.addEventListener("load", () => {
	setupLoginExtension();
	if (localStorage.getItem("email") == null) {
		const $prePopulatedEmail = $("#pre-populated-email");
		if($prePopulatedEmail.length > 0) {
			$prePopulatedEmail.closest("form").find("#password").hide();
			const $loginButton = $prePopulatedEmail.closest("form").find("#btn-login");
			if ($loginButton.length > 0) {
				$loginButton.addClass("not-allowed");
				$loginButton.attr("disabled", "disabled");
			}
		}
	}
});